// Mirror of internal/i18n/languages.go: adding a language is a row in both, plus its phrase file.

/** A BCP 47 code from LANGUAGES. */
export type LanguageCode = string

export interface LanguageInfo {
  code: LanguageCode
  /** In English. */
  name: string
  /** In itself, as a language button shows it. */
  native: string
  rtl?: boolean
  /** Offered for staff screens: reviewed by a native speaker. */
  released?: true
}

/** The language every phrase is written in first; a missing word falls back to it. */
export const SOURCE_LANGUAGE: LanguageCode = 'en'

export const LANGUAGES: readonly LanguageInfo[] = [
  { code: 'en', name: 'English', native: 'English', released: true },
  { code: 'az', name: 'Azerbaijani', native: 'Azərbaycanca' },
  { code: 'ru', name: 'Russian', native: 'Русский' },
  { code: 'tr', name: 'Turkish', native: 'Türkçe' },
  { code: 'pl', name: 'Polish', native: 'Polski' },
  { code: 'fil', name: 'Filipino', native: 'Filipino' },
  { code: 'de', name: 'German', native: 'Deutsch' },
  { code: 'fr', name: 'French', native: 'Français' },
  { code: 'es', name: 'Spanish', native: 'Español' },
  { code: 'uz', name: 'Uzbek', native: 'Oʻzbekcha' },
  { code: 'kk', name: 'Kazakh', native: 'Қазақша' },
  { code: 'ka', name: 'Georgian', native: 'ქართული' },
]

export const isKnownLanguage = (code: string): boolean => LANGUAGES.some((l) => l.code === code)

/** The languages staff screens offer, in menu order (internal/i18n Released). */
export const RELEASED_LANGUAGES: readonly LanguageCode[] = LANGUAGES.filter((l) => l.released).map((l) => l.code)

/** An organisation's languages (GET/PUT /organisation/languages): customer languages only. */
export interface LanguageSettings {
  /** Kiosk, displays, tickets, booking, messages; first is the default. */
  customer: LanguageCode[]
}
